
export default (state = {}, action) => {
  switch (action.type) {
    case 'HUDDLE_LIST_BEGINS':
      return {
        loader: true,
        error: false,
        result: null,
        count:0
      
      }
    case 'HUDDLE_LIST_SUCCESS':
      return {
        loader: false,
        error: false,
        result: action.payload.data,
        count:action.payload.totalCount
    
      }
    case 'HUDDLE_LIST_FAILURE':
      return {
        loader: false,
        error: false,
        result: null,
        count:0
      

      }
    case 'HUDDLE_DELETE_SUCCESS':
      return {
        loader: false,
        error: false,
        result: state.result.filter(item =>!action.payload.includes(item.id)),
        count: state.count -1>=0?state.count -1:0
      

      }
   
    default:
      return state
  }
}